import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'hasPermissionWithId'
})
export class HasPermissionWithIdPipe implements PipeTransform {

  transform<T extends { permissions: { permissionCode: string }[] }>(
    entity: T | null | undefined,
    permissionCode: string
  ): boolean {
    if (!entity) {
      return false;
    }

    return entity.permissions.some(p => p.permissionCode == permissionCode);
  }
}